import { Button, Container, Stack, Text, Title } from '@mantine/core';
import { Link } from 'wouter';

export default function NotFoundPage() {
	return (
		<Container size="sm" py="xl">
			<Stack gap="xl" align="center" mt={100}>
				<Title order={1} size={120} fw={900} c="dimmed">
					404
				</Title>
				<Stack gap="md" ta="center">
					<Title order={2}>Page Not Found</Title>
					<Text size="lg" c="dimmed" maw={400}>
						The page you&apos;re looking for doesn&apos;t exist or has been
						moved.
					</Text>
				</Stack>
				<Button component={Link} href="/" size="lg" variant="filled">
					Go Home
				</Button>
			</Stack>
		</Container>
	);
}
